import type { AnyRouter } from "@tanstack/react-router";

export function openNoteModal(router: AnyRouter, noteId: string) {
  router.navigate({
    to: ".",
    search: (prev: Record<string, unknown>) => ({ ...prev, note: noteId }),
  });
}

export function closeNoteModal(router: AnyRouter) {
  router.navigate({
    to: ".",
    search: (prev: Record<string, unknown>) => {
      const { note, ...rest } = prev;
      return rest;
    },
  });
}

export function openEntityModal(router: AnyRouter, entityId: string) {
  router.navigate({
    to: ".",
    search: (prev: Record<string, unknown>) => ({ ...prev, entity: entityId }),
  });
}

export function closeEntityModal(router: AnyRouter) {
  router.navigate({
    to: ".",
    search: (prev: Record<string, unknown>) => {
      const { entity, ...rest } = prev;
      return rest;
    },
  });
}
